export default "__VITE_ASSET__jIGvvb7x__"